import { createContext, useContext, useState, useEffect } from "react";
import { useT } from "../lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("taeste_lang") || "de");
  useEffect(() => {
    localStorage.setItem("taeste_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useT(lang);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
